<template>
  <div class="footer">
    <div class="wrap1200">
      <div class="footer-list">
        <div class="footer-title">
          产品
        </div>
        <div
          v-for="(item,index) in productShortList.eightList"
          :key="`eight_${index}`"
          class="footer-item product-item"
          @click="goOrder(item)"
        >
          {{ item.saleName }}
        </div>
        <div
          v-for="(item,index) in productShortList.excessList"
          v-show="excessShow"
          :key="`excess_${index}`"
          class="footer-item product-item"
          @click="goOrder(item)"
        >
          {{ item.saleName }}
        </div>
        <div
          v-if="productShortList.excessList.length !== 0"
          class="more"
          @click="excessShow = !excessShow"
        >
          <span>{{ excessShow ? '收起' : '更多' }}</span>
          <Icon
            :size="18 "
            :type="`md-arrow-drop${excessShow ? 'up' : 'down'}`"
          />
        </div>
      </div>
      <div class="footer-list">
        <div class="footer-title">
          联系我们
        </div>
        <div class="footer-item">
          电话：0571-28118688
        </div>
        <div class="footer-item">
          传真：0571-28118688
        </div>
        <div class="footer-item">
          邮箱：zhiyoubao@zhiyoubao.com
        </div>
        <div class="footer-item">
          商务合作：zhiyoubao@zhiyoubao.com
        </div>
        <div class="footer-item">
          地址： 杭州市西湖区文三路90号东部软件园6号楼6层
        </div>
      </div>
      <div class="footer-list">
        <div class="footer-title">
          加入我们
        </div>
        <div class="footer-item">
          <a
            href="https://www.zhiyoubao.com/aboutUs.htm"
          >关于我们</a>
        </div>
        <div class="footer-item">
          <a
            href="https://www.zhiyoubao.com/cooperation.htm"
          >渠道合作</a>
        </div>
        <div
          class="footer-item"
          style="text-align: center"
        >
          <img
            src="@/assets/images/footer_QRcode.png"
            alt=""
            class="QR-code"
          >
          <div class="QR-tip">
            微信扫码关注  获取最新资讯
          </div>
        </div>
      </div>
      <div class="bottom-info">
        <span>© 2013-{{ nowYear }}  浙江智游宝信息科技有限公司</span>
        <a
          style="color:#8b8d95"
          href="https://beian.miit.gov.cn/"
          target="_black"
        >浙ICP备09019008号-6</a><span>工业和信息化部备案管理系统网站</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      excessShow: false,
      nowYear: new Date().getFullYear(),
    };
  },
  computed: {
    productShortList(){
      const productShortList = this.$store.state.menu.productShortList;
      let eightList = [];
      let excessList = [];
      if (productShortList.length > 8){
        eightList = productShortList.slice(0,8);
        excessList= productShortList.slice(8,productShortList.length);
      } else {
        eightList = productShortList;
      }
      return {eightList,excessList};
    },
  },
  methods: {
    goOrder(item){
      this.$router.push({
        path: '/standardProduct/productVersion/index',
        query: {
          productCode: item.productCode,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@textColor: #8b8d95;
@titleColor: #c1c3cb;
.wrap1200 {
  width: 1200px;
  margin: 0 auto;
}
.footer {
  min-height: 500px;
  background-color: #0c1226;
  color: #8b8d95;
  .wrap1200 {
    height: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 80px 40px 80px;
    position: relative;
    .bottom-info {
      position: absolute;
      bottom: 0;
      height: 68px;
      line-height: 68px;
      width: 1140px;
      text-align: center;
      border-top: 1px solid #1e222f;
      span {
        margin: 0 18px;
        font-size: 12px;
      }
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    color: @titleColor;
    margin-bottom: 38px;
  }
  &-item {
    font-size: 14px;
    margin-bottom: 16px;
    color: @textColor;
    a {
      color: @textColor;
      &:hover {
        color: @titleColor;
      }
    }
    .QR-code {
      width: 140px;
      height: 140px;
    }
    .QR-tip {
      font-size: 12px;
    }
  }
}
.product-item {
  cursor: pointer;
}
.more{
  display: flex;
  cursor: pointer;
  color: @titleColor;
  font-size: 12px;
}
</style>
